import { useTranslation } from 'react-i18next';
import { trDisplay } from '../../i18n';
import React, { useEffect, useMemo, useState } from 'react';

const SWRSectionNav = ({ sections = [] }) => {
  useTranslation();
  const visibleSections = useMemo(
    () => sections.filter(section => section?.id && section?.label),
    [sections]
  );
  const [activeId, setActiveId] = useState(visibleSections[0]?.id || null);

  useEffect(() => {
    if (!visibleSections.length || typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      entries => {
        const visibleEntry = entries
          .filter(entry => entry.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];

        if (visibleEntry?.target?.id) {
          setActiveId(visibleEntry.target.id);
        }
      },
      {
        root: null,
        rootMargin: '-18% 0px -70% 0px',
        threshold: [0, 0.1, 0.25],
      }
    );

    visibleSections.forEach(section => {
      const element = document.getElementById(section.id);
      if (element) observer.observe(element);
    });

    return () => observer.disconnect();
  }, [visibleSections]);

  if (!visibleSections.length) return null;

  const handleClick = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (!element) return;
    setActiveId(sectionId);
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <nav
      className="swr-section-nav"
      aria-label={trDisplay("Navigazione sezioni Safe Withdrawal Rate")}
    >
      <div className="swr-section-nav__panel">
        <div className="swr-section-nav__collapsed">
          {trDisplay(visibleSections.map(section => (
            <button
              key={section.id}
              type="button"
              onClick={() => handleClick(section.id)}
              className={`swr-section-nav__bar ${activeId === section.id ? 'swr-section-nav__bar--active' : ''}`}
              aria-label={trDisplay(section.label)}
            />
          )))}
        </div>

        <div className="swr-section-nav__expanded">
          {trDisplay(visibleSections.map(section => (
            <button
              key={section.id}
              type="button"
              onClick={() => handleClick(section.id)}
              className={`swr-section-nav__item ${activeId === section.id ? 'swr-section-nav__item--active' : ''}`}
            >
              <span className="swr-section-nav__dot" />
              <span className="swr-section-nav__label">{trDisplay(section.label)}</span>
            </button>
          )))}
        </div>
      </div>
    </nav>
  );
};

export default SWRSectionNav;
